import { configureStore } from "@reduxjs/toolkit";
import PropertyListingSlice from "../Slice/PropertyListingSlice";
import PropertyVerificationSlice from "../Slice/PropertyVerificationSlice";
import SubscriptionSlice from "../Slice/SubscriptionSlice";
import ManagerSlice from "../Slice/ManagerSlice";
import AllusersSlice from "../Slice/usersSlice";
import transactionsSlice from "../Slice/transactionsSlice";
import dashboardDataSlice from "../Slice/dashboardDataSlice";
import supportSlice from "../Slice/supportSlice";
import InvestorySlice from "../Slice/InvestorySlice";
import InvestorPaymentSlice from "../Slice/InvestorPaymentSlice";
import ProfileSlice from "../Slice/ProfileSlice";
import InvestorReducer from "../Slice/InvestorSlice";

export const store = configureStore({
    reducer: {
        investor: InvestorReducer,
        propertylisting: PropertyListingSlice,
        propertyverification: PropertyVerificationSlice,
        SubscriptionData: SubscriptionSlice,
        ManagerData: ManagerSlice,
        allUsers: AllusersSlice,
        transactions: transactionsSlice,
        dashboardData: dashboardDataSlice,
        support: supportSlice,
        investoryManagment: InvestorySlice,
        InvestorPayments: InvestorPaymentSlice,
        AdminProfile: ProfileSlice
    }
});

export default store;
